import React from 'react'
import Navbarmenu from './Navbarmenu';
import './EntrylevelContent.css';
import Container from '@material-ui/core/Container';

 function EntrylevelContent() {
    return (
        <>
            <div className="main-container" id="entrylevelcontent-box">
                <title>Security Learning - Entry Level</title>
                <img src={process.env.PUBLIC_URL +"/images/entry-level-banner.png"} className="banner-img"/>
                <Navbarmenu/>
            </div>
            <Container className='entry-level-container' maxWidth="xl">
                {/* section-1 */}
                <p>Here is the Security learning guidance for entry and lateral resources to equip with the knowledge of some of the key security aspects as applicable to the different phases of SDLC. For security specialists playing security roles, there is a focus on deeper aspects of security learning.</p>
                <div className="entry-level-wrap">
                    <h3>Entry Level:</h3>
                    <p>The Tech Expressway journey helps to build ASEs in terms of end-to-end core engineering skills incubated over 2 years. ASEs will get an opportunity to develop cutting edge skills as per business needs, thereby keeping themselves relevant and future ready.</p>
                </div>
                {/* section-2 */}
                <div className="learning-format-wrap">
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <h2>Primer</h2>
                                        <img src={process.env.PUBLIC_URL +"/images/90-Days-before-joining.png"} alt="security-learning" className="learn-format-img" />
                                        <p>2-3 hrs of security fundamentals covered along with career track primer</p>
                                    </div>
                                    <div class="flip-card-back">
                                        <h2>Primer</h2>
                                        <h3>(After onboarding)</h3>
                                        <h2>Topics Covered: </h2>
                                    
                                    <ul>   
                                    <li> <h3 style={{textAlign: "left"}}>Security Fundamentals  </h3> </li>
                                    <li>  <h3 style={{textAlign: "left"}}> Cloud & Cloud Security Fundamentals  </h3> </li>
                                    <li> <h3 style={{textAlign: "left"}}> Security Concepts </h3> </li>
                                    </ul> 
                                        
                                    </div>
                                </div>
                            </div>
                            {/* <a href="#"><img src="/images/90-Days-before-joining.png" alt="security-learning" className="learn-format-img" /></a>
                            <h2>90 Days <br /> before joining</h2>
                            <h3>Techstart</h3>
                            <p>250+ hours of security fundamentals covered in 90 days</p> */}
                        </div>
                    </div>
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <h2>TechGenics</h2>
                                        <img src={process.env.PUBLIC_URL +"/images/First-10-days.png"} alt="security-learning" className="learn-format-img" />
                                        <p>Undergo orientation relevant to different technology streams which 
                        includes 4-6 hours of secure SDLC</p>
                                    </div>
                                    <div class="flip-card-back">
                                        <h2>TechGenics</h2>
                                        <h3>(2 weeks to 6  months)</h3>

                                        <h2>Topics Covered: </h2>
                                    
                                    <ul>   
                                    <li> <h3 style={{textAlign: "left"}}>Secure Coding Concepts </h3> </li>
                                    <li>  <h3 style={{textAlign: "left"}}> OWASP Top-10  </h3> </li>
                                    <li> <h3 style={{textAlign: "left"}}> Secure Code Review</h3> </li>
                                    <li> <h3 style={{textAlign: "left"}}> Secure Coding Checklists</h3> </li>
                                    </ul> 
                                    </div>
                                </div>
                            </div>
                            {/* <a href="#"><img src="/images/First-10-days.png" alt="security-learning" className="learn-format-img" /></a>
                            <h2>First 10 <br /> Days</h2>
                            <h3>Techify Foundation</h3>
                            <p>Undergo orientation relevant to different security streams</p> */}
                        </div>
                    </div>
                   
                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <h2>TechLeap </h2>
                                        <img src={process.env.PUBLIC_URL +"/images/10-days-to-4-6-months.png"} alt="security-learning" className="learn-format-img" />
                                        <p>Specialization Schools to help upskill and cross skill ASEs</p>
                                    </div>
                                     <div class="flip-card-back">
                                      <h2>TechLeap </h2> 
                                        <h3>(6-24 months)</h3>
                                        <h2>Specialization Covered:  </h2>
                                        <ul>   
                                    <li> <h3 style={{textAlign: "left"}}> DevSecOps </h3> </li>
                                    </ul>
                                    <br/> <br/>
                                    <span><a href="https://atci.techleap.accenture.com/home" target="_blank">More on TechLeap</a> </span>
                                    </div>
                                    
                                </div>
                            </div>
                            {/* <a href="#"><img src="/images/10-days-to-4-6-months.png" alt="security-learning" className="learn-format-img" /></a>
                            <h2>10 days to <br /> 4-6 months</h2>
                            <h3>TechGenics</h3>
                            <p>Learn & Apply while working: Combination of project experience, self-paced & instructor-led sessions & mentoring (~176 Hours)</p> */}
                        </div>
                    </div>


                    <div className="learning-format-row">
                        <div className="learning-format-box">
                            <div class="flip-card">
                                <div class="flip-card-inner">
                                    <div class="flip-card-front">
                                        <h2>DFA L1</h2>
                                        <img src={process.env.PUBLIC_URL +"/images/Date-of-joining-to-30-days.png"} alt="security-learning" className="learn-format-img" />
                                        <p>Career Level based mandatory online trainings of 22-26 hrs. covering fundamental delivery skills. </p>
                                    </div>
                                    <div class="flip-card-back">
                                        <h2>DFA L1</h2>
                                        <h3>(Date of joining <br /> to 30 days)</h3>
                                    </div>
                                </div>
                            </div>
                            {/* <a href="#"><img src="/images/Date-of-joining-to-30-days.png" alt="security-learning" className="learn-format-img" /></a>
                            <h2>Date of joining <br /> to 30 days</h2>
                            <h3>DFA L1</h3>
                            <p>Career Level based mandatory online trainings of 22-26 hrs. covering fundamental delivery skills. </p> */}
                        </div>
                    </div>
                

                </div>

            </Container>
        </>
    )
}
export default EntrylevelContent;